import { css } from "@emotion/react";
import primaryButtonCss from "assets/css/buttons/primaryButton.css";
import colors from "assets/css/colors";
import fontSize from "assets/css/fontSize";
import fontWeight from "assets/css/fontWeight";
import lineHeight from "assets/css/lineHeight";

export const gap16Css = css`
  gap: 16px;
`;

export const gap32Css = css`
  gap: 32px;
`;

export const submitBtnCss = [
  primaryButtonCss,
  css`
    align-self: self-start;
  `,
];

export const profileSubtitleCss = css`
  margin: 0 0 16px;
  color: ${colors.mainBlack};
  font-size: ${fontSize.lg};
  font-weight: ${fontWeight.medium};
  line-height: ${lineHeight.md};
`;
